var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "loading-dots fill-current",
      attrs: { width: "60", height: "15", viewBox: "0 0 120 30" }
    },
    [
      _c("circle", { attrs: { cx: "15", cy: "15", r: "15" } }),
      _c("circle", { attrs: { cx: "60", cy: "15", r: "15" } }),
      _c("circle", { attrs: { cx: "105", cy: "15", r: "15" } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }